module.exports = __webpack_public_path__ + "img/book.aab687db.svg";